import { ColumnDef } from "@tanstack/react-table";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import RoleRequire from "../../../../helpers/auth/RoleRequire";
import { useFetch } from "../../../../hooks/useFetch";
import { Maintenance } from "../../../../types/types";
import { Button } from "../../../../ui/Button";
import { SimpleDataTable } from "../../../../ui/DataTable/SimpleDataTable";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogOverlay, DialogTitle } from "../../../../ui/Dialog";
import { Input } from "../../../../ui/Input/Input";
import AddMaintenance from "./AddMaintenance";
import EditMaintenance from "./EditMaintenance";

type Props = {
  id: string;
};

const MaintenancesTab = ({ id }: Props) => {
  const [search, setSearch] = useState("");
  const [maintenances, setMaintenances] = useState<Maintenance[]>();
  const [selectedMaintenance, setSelectedMaintenance] = useState<Maintenance>()
  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false)
  const [openEditModal, setOpenEditModal] = useState<boolean>(false)

  const [{ response, isLoading, error }, doFetchМaintenances] = useFetch(`/directories/equipment_items/${id}/maintenances`);

  useEffect(() => {
    doFetchМaintenances();
  }, []);

  useEffect(() => {
    setMaintenances(response?.data as unknown as Maintenance[]);
  }, [response]);

  // let nodes = maintenances?.map((maintenance) => {
  //   return {
  //     id: maintenance.id,
  //     name: maintenance.attributes.description,
  //     description: maintenance.attributes.maintenance_description,
  //     type: maintenance.attributes.maintenance_type,
  //     nextMaintenanceDate: maintenance.attributes.next_maintenance_at,
  //     previousMainenanceDate: maintenance.attributes.previous_maintenance_at,
  //     maintenance_time: maintenance.attributes.maintenance_time,
  //     next_maintenance_after: maintenance.attributes.next_maintenance_after,
  //   };
  // });

  let nodes = maintenances

  nodes = _.sortBy(nodes, []);

  const columns: ColumnDef<Maintenance>[] = [
    {
      id: 'id',
      header: `${t("title_name")}`,
      size: 1000,
      cell: (props) =>
      (
        <div className="flex flex-col truncate max-w-[420px]">
          <div className="font-medium truncate ">{props.row.original.attributes.description}</div>
          <div className="font-medium truncate ">{props.row.original.attributes.maintenance_description}</div>
        </div>
      ),
    },

    {
      accessorKey: "type",
      header: t("type"),
      size: 100,
      minSize: 100,
      maxSize: 100,
      cell: (props) => t(`${props.row.original.attributes.maintenance_type}`),
    },
    {

      header: t("next_maintenance_date"),
      size: 150,
      minSize: 150,
      maxSize: 150,
      cell: (props) => (
        <div className="max-w-[420px]">
          <div className="font-medium truncate ">{DateTime.fromISO(props.row.original.attributes.next_maintenance_at).toFormat('dd.MM.yyyy')}</div>
        </div>
      ),
    },
  ];

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  nodes = nodes?.filter(
    (item) =>
      item.attributes.description.toLowerCase().includes(search.toLowerCase())
  );

  function selectMaintenance(maintenance: Maintenance) {
    setSelectedMaintenance(maintenance)
    setOpenEditModal(true)
  }
  
  function addMaintenance() {
    setOpenCreateModal(true)
  }


  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('maintenances')}</span>
        </div>
      </div>
      <div className="flex flex-col w-full">
          <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
              <Input 
                  className="h-8"
                  placeholder={t("search")}
                  onChange={handleSearch}
                  value={search}
                  autoComplete="off"
                  width="100%" 
              />
              
              <RoleRequire role="maintainer">
                  <Button variant={"default"} size={"md"} onClick={() => addMaintenance()}>{t("add_maintenances")}</Button>
              </RoleRequire>
          </div>
      </div>
      {!nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
        </div>
        ) : (
          <SimpleDataTable data={nodes} columns={columns} onClickRow={selectMaintenance}/>
        )}
        {openCreateModal && <AddMaintenanceDialog equipmentId={id} open={openCreateModal} onChange={setOpenCreateModal} updateList={doFetchМaintenances}/>}
        {selectedMaintenance && openEditModal && <EditMaintenanceDialog maintenance={selectedMaintenance!} open={openEditModal} onChange={setOpenEditModal} updateList={doFetchМaintenances}/>}
    </div>
  );
};

export default MaintenancesTab;


function AddMaintenanceDialog({equipmentId, open, onChange, updateList}:{equipmentId: string, open: boolean, onChange: (state: boolean) => void, updateList: Function}) {
  return (
    <Dialog open={open} onOpenChange={() => onChange(!open)}>
      <DialogOverlay className="bg-slate-950/40 data-[state=open]:animate-overlayShow fixed inset-0" />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("adding_maintenance")}</DialogTitle>
          <DialogDescription>{t("adding_maintenance_desc")}</DialogDescription>
          <AddMaintenance
            equipmentId={equipmentId}
            updateList={updateList}
            closeModal={() => onChange(!open)}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

function EditMaintenanceDialog({maintenance, open, onChange, updateList}:{maintenance: Maintenance, open: boolean, onChange: (state: boolean) => void, updateList: Function}) {
  return (
    <Dialog open={open} onOpenChange={() => onChange(!open)}>
      <DialogOverlay className="bg-slate-950/40 data-[state=open]:animate-overlayShow fixed inset-0" />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("editing_equipment_maintenance")}</DialogTitle>
          <DialogDescription>
            {t("equipment_maintenance_form_text")}
          </DialogDescription>
          <EditMaintenance maintenance={maintenance} updateList={updateList} closeEdit={() => onChange(!open)} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}